import React from "react"
import SongMenuModal from "./SongMenuModal"


export const ContextModals: React.FC = () =>
    <><SongMenuModal /> </>


export default ContextModals;